"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinRoundWithNft = void 0;
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const helpers_2 = require("./helpers");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const joinRoundWithNft = ({ programId, connection, addComputeUnits, priorityFees, args, accounts, optimistic, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: priorityFees });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const [round] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ROUND_PREFIX), constants_1.ENCODER.encode(args.roundNumber.toString())], program.programId);
    const userRoundSeed = Math.ceil(Math.random() * 1000000);
    const [userRound, userRoundBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.USER_ROUND_PREFIX), accounts.userPubkey.toBuffer(), constants_1.ENCODER.encode(userRoundSeed.toString())], program.programId);
    const [roundTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ROUND_TXN_VAULT_PREFIX)], program.programId);
    const [roundSettings] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ROUND_SETTING_PREFIX)], program.programId);
    const [hadespinLeaderboardEntry, hadespinLeaderboardEntryBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.HADESPIN_LEADERBOARD_ENTRY_PREFIX), accounts.userPubkey.toBuffer()], program.programId);
    const [hadespinLeaderboardWeekEntry, hadespinLeaderboardWeekEntryBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.HADESPIN_LEADERBOARD_WEEK_ENTRY_PREFIX),
        constants_1.ENCODER.encode((0, helpers_2.currentLeaderboardEntryWeek)().toString()),
        accounts.userPubkey.toBuffer(),
    ], program.programId);
    const [hadespinRakeback, hadespinRakebackBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.HADESPIN_RAKEBACK_PREFIX), accounts.userPubkey.toBuffer()], program.programId);
    const [hadespinAdditionalParticipantsVault, hadespinAdditionalParticipantsVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.HADESPIN_ADDITIONAL_PARTICIPANTS_VAULT_PREFIX)], program.programId);
    const roundNumber = new anchor_1.BN(args.roundNumber);
    const txSellNft = yield (0, helpers_2.getNftSellIx)(accounts.userPubkey, args.solInNftToDeposit, accounts.mint, accounts.pool);
    const opName = 'tswapBuyNftTx';
    const txsToSign = txSellNft.data[opName].txs.map((tx) => tx.txV0 ? web3_js_1.VersionedTransaction.deserialize(txSellNft.txV0.data) : web3_js_1.Transaction.from(tx.tx.data));
    let instructionsFromSellNft = (yield Promise.all(txsToSign.map((versionedTransaction) => __awaiter(void 0, void 0, void 0, function* () {
        return yield (0, helpers_2.getInstructionsFromVersionedTransaction)(versionedTransaction);
    })))).flat();
    instructions.push(...instructionsFromSellNft);
    const accountsIntoInstruction = {
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        round: round,
        userRound: userRound,
        user: accounts.userPubkey,
        roundSetting: roundSettings,
        roundTxnVault: roundTxnVault,
        hadespinLeaderboardEntry: hadespinLeaderboardEntry,
        rakeback: hadespinRakeback,
        additionalParticipantsVault: hadespinAdditionalParticipantsVault,
        hadespinLeaderboardWeekEntry,
    };
    instructions.push(yield program.methods
        .joinRoundWithNft(new anchor_1.BN(args.solInNftToDeposit), new anchor_1.BN(args.roundNumber), new anchor_1.BN(userRoundSeed))
        .accountsStrict(accountsIntoInstruction)
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    const optimisticResult = yield (0, helpers_2.optimisticJoinRound)({
        round: Object.assign({}, optimistic.round),
        roundNumber: args.roundNumber,
        roundSettings: Object.assign({}, optimistic.roundSettings),
        hadespinLeaderboardEntry: Object.assign(Object.assign({}, optimistic.hadespinLeaderboardEntry), { publicKey: hadespinLeaderboardEntry.toBase58() }),
        hadespinLeaderboardWeekEntry: Object.assign(Object.assign({}, optimistic.hadespinLeaderboardWeekEntry), { publicKey: hadespinLeaderboardWeekEntry.toBase58() }),
        roundPubKey: round.toString(),
        userRoundPubKey: userRound.toString(),
        userPubkey: accounts.userPubkey.toString(),
        solToDeposit: 0,
        programId: program.programId.toString(),
        solInNftToDeposit: args.solInNftToDeposit,
        nftMint: constants_1.EMPTY_PUBKEY.toBase58(),
        hadespinRakeback: optimistic.hadespinRakeback,
    });
    return {
        instructions,
        signers,
        optimisticResult,
    };
});
exports.joinRoundWithNft = joinRoundWithNft;
